<template>
  <div class="nav-mobile">
    <div @click="$emit('toggleNav')" class="links">
      <a href="#features" v-smooth-scroll> Features </a>
      <a href="#educators" v-smooth-scroll> Educators </a>
      <a href="#resources" v-smooth-scroll> Resouces </a>
      <a href="#pricing" v-smooth-scroll> Pricing </a>
      <a href="#FAQs" v-smooth-scroll> FAQs </a>
      <a class="highlight-button" href="https://creator.eyejack.io" target="_blank" alt="link 1">Try it Now!</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavbarMobile",
};
</script>

<style lang="scss" scoped>
@import "../styles/styles.scss";

.nav-mobile {
  z-index: -1;
  position: absolute;
  top: 10px;
  right: 0;
  height: 100vh;
  .links {
    transform: translateX(150px);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 0;
    position: relative;
    top: 30px;
    right: 0px;
    .highlight-button {
      background: #e95557;
      padding: 1em 1.35em;
      color: white;
      border-radius: 6px;
      border: 2px solid #e95557;

    }
    .highlight-button:hover {
      background: white;
      color: #e95557;
      border: 2px solid #e95557;
    }
  }
}

.links > * {
  padding: 1em 0;
  letter-spacing: 1.55px;
  font-size: 1em;
  text-decoration: none;
  &:hover {
    color: #e95557;
  }
}
.highlight-button {
  width: 142px;
}
</style>